import { render, staticRenderFns } from "./addRoleEdit.vue?vue&type=template&id=53ad12a0&scoped=true&"
import script from "./addRoleEdit.vue?vue&type=script&lang=js&"
export * from "./addRoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./addRoleEdit.vue?vue&type=style&index=0&id=53ad12a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad12a0",
  null
  
)

component.options.__file = "addRoleEdit.vue"
export default component.exports